$(document).ready(function (){
    $("#form-select-month-and-year").on('submit', function (e){
        e.preventDefault()
        let data = new FormData(this)
        sendData(data,'reporte-clientes-consentidos-por-mes-result','div_result-clientes-consentidos-por-mes')
    })

    function sendData(data, route,div_id) {
        togglePreloader();
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(() => {
                    togglePreloader();
                    document.getElementById(div_id).innerHTML = response;
                }, 1000);

            }, error: function (errors, xhr, status,) {
                togglePreloader();
                var indices = errors.responseJSON.errors;

            }
        })
    }
})
